import { AfterViewChecked, Directive, ElementRef, Input, Renderer2 } from '@angular/core';

import { POSITION_PROPERTY } from '../constants';

@Directive({
    selector: '[atx-fixed]',
})

export class AtxFixedDirective implements AfterViewChecked {
    @Input() public readonly position: string;

    constructor(
        private readonly el: ElementRef,
        private readonly render: Renderer2,
    ) {}

    public ngAfterViewChecked() {
        const { nativeElement } = this.el;
        const elementStyle = nativeElement[POSITION_PROPERTY[this.position]].style;
        const paddingCount = nativeElement.clientHeight || nativeElement.firstElementChild.offsetHeight;

        this.render.addClass(nativeElement, `fixed-${ this.position }`);

        elementStyle.display = 'block';
        elementStyle[`padding-${ this.position }`] = `${ paddingCount }px`;
    }
}
